// JsFromRoutes CacheKey 7e2a4f8affac46ea0030844d50ee76a4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/all'),
  upcomingBirthdays: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/upcoming_birthdays'),
  informationMissing: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/information_missing'),
  potentialDuplicates: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/potential_duplicates'),
  archived: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/archived'),
  show: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/all/:id'),
  upcomingBirthdaysContact: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/upcoming_birthdays/:id'),
  informationMissingContact: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/information_missing/:id'),
  potentialDuplicatesContact: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/potential_duplicates/:id'),
  archivedContact: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/archived/:id'),
  giftRecommendations: /* #__PURE__ */ definePathHelper('get', '/my-account/contacts/:id/gift-recommendations'),
}
